var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M512,256c0-31.314-5.633-61.311-15.923-89.043L256,155.826l-240.077,11.13 C5.633,194.689,0,224.686,0,256s5.633,61.311,15.923,89.043L256,356.174l240.077-11.13C506.367,317.311,512,287.314,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M15.923,166.957h480.155C459.906,69.472,366.071,0,256,0S52.094,69.472,15.923,166.957z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "322.783,178.088 278.261,178.088 285.682,122.435 315.362,100.174 345.043,122.435  345.043,166.957  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "189.217,178.088 233.739,178.088 226.318,122.435 196.637,100.174 166.957,122.435  166.957,166.957  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "285.682,178.088 226.318,178.088 226.318,122.435 256,100.174 285.682,122.435 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M166.957,166.958v122.434c0,29.153,14.082,55.079,35.802,71.332l15.583-3.899l19.664,19.782 c5.815,1.198,11.832,1.829,17.995,1.829c6.13,0,12.117-0.623,17.901-1.809l22.447-18.69l12.892,2.751 c21.711-16.252,35.803-42.151,35.803-71.296V166.958H166.957z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 166.957,
    y: 166.957,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.191,
    y: 166.957,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.426,
    y: 166.957,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.574,
    y: 202.574,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.809,
    y: 202.574,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.957,
    y: 238.18,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.574,
    y: 273.798,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.191,
    y: 238.18,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.426,
    y: 238.18,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.809,
    y: 273.798,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.191,
    y: 309.415,
    style: {
      fill: "#D80027"
    },
    width: 35.617,
    height: 35.617
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M202.574,309.418h-33.319c3.056,13.24,9.064,25.355,17.302,35.617h16.017V309.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M309.426,345.036h16.016c8.24-10.262,14.246-22.378,17.302-35.617h-33.318V345.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M202.574,345.036v15.541c10.359,7.795,22.465,13.384,35.617,16.066v-31.607H202.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M273.809,345.036v31.607c13.153-2.68,25.258-8.271,35.617-16.066v-15.541H273.809z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/hr.d894134b0aad2ffbdc81c61afd6572fa.svg";
export { ForwardRef as ReactComponent };